module.exports = __webpack_public_path__ + "img/ir.7e6ba74d.svg";